import React from 'react';
import {
  MenuItem,
  Grid,
  TextField,
  Stack,
} from '@mui/material';
import {
  ChipSelectList,
  DebouncedSearchInput,
  MultiCountrySelector,
} from '@marageti/z4-lib';
import PartnerSelector from '../../../components/partner-selector';
import TripSearchDateRangeFilters, {
  TripSearchDateRangeKey,
} from '../../../components/trip-search-date-range-filters/trip-search-date-range-filters';
import { statusChipOptions, salesStageChipOptions, sortByOptionsAllTrips } from '../options';

type AllTripsFiltersProps = {
  countries: string[],
  departureDateFrom: string;
  departureDateTo: string;
  disableSalesStageChips: boolean,
  disableSortBy: boolean;
  matchDateFrom: string;
  matchDateTo: string;
  onChange: (n: string, v: string | string[]) => void;
  partner: string;
  searchValue: string;
  selectedSalesStageChips: string[];
  selectedStatusChips: string[];
  sortBy: string;
};

const AllTripsFilters = ({
  countries,
  departureDateFrom,
  departureDateTo,
  disableSalesStageChips,
  disableSortBy,
  onChange,
  partner,
  searchValue,
  selectedSalesStageChips,
  selectedStatusChips,
  sortBy,
  matchDateFrom,
  matchDateTo,
}: AllTripsFiltersProps) => {
  const onDateChange = (name: TripSearchDateRangeKey, value: string) => {
    onChange(name, value);
  };

  return (
    <>
      <Grid container spacing={{ mobile: 0, desktop: 2 }} mb={0} gap={0}>
        <Grid item mobile={12} desktop={3}>
          <DebouncedSearchInput
            fullWidth
            key="fullText"
            label="Search"
            name="fullText"
            onChange={(v) => onChange('fullText', v)}
            defaultValue={searchValue}
          />
        </Grid>
        <Grid item mobile={12} desktop={3}>
          <MultiCountrySelector
            key="destination-select"
            label="Countries"
            name="countries"
            onChange={(e: React.SyntheticEvent, value: string[]) => onChange('countries', value)}
            value={countries}
          />
        </Grid>
        <Grid item mobile={12} desktop={3}>
          <PartnerSelector
            key="partner-select"
            label="Partner"
            name="partner"
            onChange={(_: React.SyntheticEvent, value: string) => onChange('partner', value)}
            value={partner}
          />
        </Grid>
        <Grid item mobile={12} desktop={3}>
          <TextField
            key="sort-by-select"
            label="Sort By"
            name="sort"
            onChange={(e) => onChange('sort', e.target.value)}
            select
            sx={{
              width: '100%',
              '& .MuiSelect-icon > svg > path': { color: 'primary.main' },
            }}
            disabled={disableSortBy}
            value={sortBy}
          >
            {sortByOptionsAllTrips.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.title}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Grid container spacing={{ mobile: 0, desktop: 2 }} mb={4}>
        <Grid item mobile={12} desktop={12}>
          <TripSearchDateRangeFilters
            departureDateFrom={departureDateFrom}
            departureDateTo={departureDateTo}
            matchDateFrom={matchDateFrom}
            matchDateTo={matchDateTo}
            onChange={onDateChange}
          />
        </Grid>
        <Grid item mobile={12} desktop={12}>
          <Stack
            direction={{
              mobile: 'column', desktop: 'row',
            }}
            spacing={{
              mobile: 2, desktop: 4,
            }}
          >
            <ChipSelectList
              chipOptions={statusChipOptions}
              label="Status"
              onChange={(v: string[]) => onChange('status', v)}
              selectedChips={selectedStatusChips}
            />
            <ChipSelectList
              chipOptions={salesStageChipOptions}
              label="Sales Stage"
              onChange={(v: string[]) => onChange('salesStage', v)}
              selectedChips={selectedSalesStageChips}
              chipProps={{
                disabled: disableSalesStageChips,
              }}
            />
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};

export default AllTripsFilters;
